import { useState } from "react";

interface TabItem {
  id: string;
  label: string;
  content: React.ReactNode;
}

const tabs: TabItem[] = [
  {
    id: "current-openings",
    label: "Current Job Openings",
    content: (
      <div className="py-4">
        <h5 className="text-2xl font-medium text-primary-600">
          There are currently no open positions. Please check back soon.
        </h5>
      </div>
    ),
  },
  {
    id: "working-for",
    label: "Working for Southern Transit",
    content: (
      <div className="py-4 space-y-4 text-foreground-700 leading-relaxed">
        <p>
          Thank you for your interest in employment with Southern Transit LLC. Everyday Southern Transit employees make a difference in their public service to the Trinidad community. We're seeking high-caliber team players who share our values and our drive to be the best. We are committed to providing excellent employment opportunities for talented, passionate individuals that enjoy being part of an innovative, results-oriented organization that is growing and expanding. Southern Transit LLC is an equal opportunity employer that encourages all qualified individuals to apply.
        </p>
        <p>
          Southern Transit LLC offers excellent benefits for full-time employees, including health insurance, paid time off (PTO), and a retirement plan. Housing at a discounted rate for the right employee.
        </p>
        <p>
          Each job opening is listed with a job description that describes the duties, responsibilities and qualifications for the position. If you are interested in a job that is not currently open, you may send an application for the position, and it will be held for up to one year. You will be notified via email when the job opens for recruitment. Applicants are advised that Southern Transit LLC is a drug-free workplace and pre-employment drug tests and background checks are required by the Department of Transportation.
        </p>
        <p>
          For driving positions, applicants must be 21 years of age or older, and possess a valid, unrestricted Colorado Driver's License and a clean driving record. If you do not currently have a Class B license Commercial Driver's License (CDL), Southern Transit LLC does provide training for applicants who qualify. Driving positions are usually part time to start. Full-time employees are eligible for benefits.
        </p>
        <p>
          Resumes, Cover Letters, and/or Applications can be sent to:
          <br />
          Email:{" "}
          <a
            href="mailto:lynn@southerntransit.us"
            className="text-primary-600 hover:underline"
          >
            lynn@southerntransit.us
          </a>
          <br />
          Phone: (712) 206-1196
          <br />
          Mail: Southern Transit LLC
          <br />
          9245 County Road 43.6
          <br />
          Trinidad, CO 81082
        </p>
        <p>
          <strong className="text-foreground-800">
            <span>Equal Opportunity Statement</span>
          </strong>
        </p>
        <p>
          Southern Transit LLC is an equal opportunity employer. Applicants shall not be discriminated against because of race, color, sex, sexual orientation, gender identity, age, religion, national origin, disability, ancestry, marital status, veteran status, medical condition or any protected category prohibited by local, state, or federal laws. Southern Transit LLC will make reasonable efforts to accommodate persons with disabilities or for religious reasons. Please advise Southern Transit LLC of any special needs in advance of employment.
        </p>
        <p>
          Southern Transit LLC is committed to compliance with Title VI for the Civil Rights Act of 1964 and all related regulations and directives. Southern Transit LLC assures that no person shall on the grounds of race, color, national origin, gender, age, or disability be excluded from participation in, be denied the benefits of, or be otherwise subjected to discrimination under any DOT service, program, or activity. The department also assures that every effort will be made to prevent discrimination through the impacts of its programs, policies, and activities on minority and low-income populations. In addition, the department will take reasonable steps to provide meaningful access to services for persons with Limited English Proficiency. For questions, please call (712) 206-1196 for meaningful access to services for persons with Limited English Proficiency.
        </p>
      </div>
    ),
  },
];

export default function CareerTabs() {
  const [activeTab, setActiveTab] = useState("current-openings");
  const [mobileOpenTab, setMobileOpenTab] = useState<string | null>("current-openings");

  const activeContent = tabs.find((t) => t.id === activeTab)?.content;

  return (
    <div className="w-full">
      {/* Desktop: vertical tabs */}
      <div className="hidden lg:flex gap-0">
        {/* Left tab nav */}
        <div className="w-[280px] shrink-0 border-r border-background-200/70">
          <ul className="flex flex-col" role="tablist">
            {tabs.map((tab) => {
              const isActive = activeTab === tab.id;
              return (
                <li key={tab.id} role="presentation">
                  <button
                    role="tab"
                    aria-selected={isActive}
                    onClick={() => setActiveTab(tab.id)}
                    className={`w-full text-left px-5 py-4 text-lg italic transition-colors border-l-4 ${
                      isActive
                        ? "border-primary-500 text-primary-600 bg-background-50"
                        : "border-transparent text-foreground-600 hover:text-primary-600 hover:bg-background-50/50"
                    }`}
                  >
                    {tab.label}
                  </button>
                </li>
              );
            })}
          </ul>
        </div>

        {/* Right content */}
        <div className="flex-1 pl-8 min-w-0">
          {activeContent}
        </div>
      </div>

      {/* Mobile: accordion */}
      <div className="lg:hidden space-y-2">
        {tabs.map((tab) => {
          const isOpen = mobileOpenTab === tab.id;
          return (
            <div key={tab.id} className="border border-background-200/70 rounded-lg overflow-hidden">
              <button
                onClick={() => setMobileOpenTab(isOpen ? null : tab.id)}
                className={`w-full text-left px-4 py-3 text-base italic transition-colors flex items-center justify-between ${
                  isOpen
                    ? "text-primary-600 bg-background-50"
                    : "text-foreground-600 hover:text-primary-600"
                }`}
              >
                <span>{tab.label}</span>
                <i
                  className={`ri-arrow-down-s-line text-xl transition-transform ${
                    isOpen ? "rotate-180" : ""
                  }`}
                />
              </button>
              {isOpen && (
                <div className="px-4 pb-4 border-t border-background-200/70">
                  {tab.content}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}